export const getWidgetParamName = (paramName: string, widget: { ID: string | number }) => {
  return `${paramName}|${widget.ID}`;
};
